function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pets_svg__clip0_1_64)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.366 16c3.672 0 6.405-3.835 6.405-7.222 0-.775-.163-1.51-.408-2.244v-.122L12.65.903a.873.873 0 00-.367-.734.833.833 0 00-.816-.04C10.73.535 8.406 1.8 7.59 2.453a6.15 6.15 0 00-2.285-.041C4.489 1.76 2.204.495 1.469.087a.833.833 0 00-.816.041C.408.291.245.577.286.862l.286 5.264A6.26 6.26 0 000 8.737C-.04 12.165 2.693 16 6.366 16zm4.447-11.833c-.204-.204-.408-.367-.612-.53a3.103 3.103 0 00-.775-.49c.408-.244.938-.57 1.469-.856l-.082 1.876zm-1.491.63a5.115 5.115 0 011.562 1.984c.253.634.38 1.267.38 1.942 0 2.871-2.07 5.193-4.096 5.7v-1.309a1.834 1.834 0 001.056-1.689c0-1.055-.845-.886-1.858-.886-1.055 0-1.857-.127-1.857.886 0 .718.38 1.31.97 1.647v1.35c-2.026-.548-4.052-2.828-4.052-5.656 0-.676.126-1.351.422-1.985a.456.456 0 00.127-.295c.084-.211.21-.38.337-.549.422-.591 1.014-1.14 1.647-1.478a4.31 4.31 0 011.224-.464c.38-.085.76-.127 1.182-.127a3.9 3.9 0 011.225.085 5.087 5.087 0 011.73.844zm-5.976-1.69c-.04 0-.04.04-.081.04-.45.245-.857.53-1.224.898l-.082-1.754c.49.285.98.57 1.387.816zm1.755 4.365a.806.806 0 01.245.572.806.806 0 01-.245.57.806.806 0 01-.572.246.806.806 0 01-.57-.245.806.806 0 01-.246-.571.81.81 0 01.245-.572c.286-.326.816-.326 1.143 0zM7.59 8.615a.806.806 0 01-.245-.571c0-.204.081-.408.245-.572.326-.285.856-.285 1.142 0a.806.806 0 01.245.572.806.806 0 01-.245.57.806.806 0 01-.571.246.806.806 0 01-.571-.245z",
  fill: "currentColor"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pets_svg__clip0_1_64"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h13v16H0z"
})));

function SvgPets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgPets;